export class CurrentPipelineColumns {
    status;
    properties;
    totalPrice;
    totalGrossFee;
    split;
    striveGrossFee;

    constructor({status, transactionYear, data, negData, ucData, closedData, closedOtherData}) {
        this.status = transactionYear ? `${status} ${transactionYear}`: status;
        switch (status) {
            case 'Active':
                this.properties = data.TOTAL_PROPERTIES ? parseInt(data.TOTAL_PROPERTIES) : 0;
                this.totalPrice = data.TOTAL_LIST_PRICE ? parseFloat(data.TOTAL_LIST_PRICE) : 0;
                this.totalGrossFee = data.TOTAL_FEE_LIST ? parseFloat(data.TOTAL_FEE_LIST) : 0;
                this.split = null;
                this.striveGrossFee = null;
                break;
            case 'In Negotiation':
            case 'Under Contract':
            case 'Other Neg/UC': {
                this.properties = data.TOTAL_PROPERTIES ? parseInt(data.TOTAL_PROPERTIES) : 0;
                this.totalPrice = data.TOTAL_NEGOTIATION_PRICE ? parseFloat(data.TOTAL_NEGOTIATION_PRICE) : 0;
                this.totalGrossFee = data.TOTAL_FEE_NEGOTIATION ? parseFloat(data.TOTAL_FEE_NEGOTIATION) : 0;
                const listSplit = data.LISTING_SPLIT_W_OA ? parseFloat(data.LISTING_SPLIT_W_OA) : 0;
                const buySplit = data.BUYING_SPLIT_W_OA ? parseFloat(data.BUYING_SPLIT_W_OA) : 0;
                const refListSplit = data.LISTING_SPLIT_W_RA ? parseFloat(data.LISTING_SPLIT_W_RA) : 0;
                const refBuySplit = data.BUYING_SPLIT_W_RA ? parseFloat(data.BUYING_SPLIT_W_RA) : 0;
                this.split = listSplit + buySplit + refBuySplit + refListSplit;
                this.striveGrossFee = this.totalGrossFee - this.split;
                break;
            }
            case 'Closed':
            case 'Closed YTD':
            case 'Other Closed YTD': {
                this.properties = data.TOTAL_CLOSED_PROPERTIES ? parseInt(data.TOTAL_CLOSED_PROPERTIES) : 0;
                this.totalPrice = data.TOTAL_CLOSED_PRICE ? parseFloat(data.TOTAL_CLOSED_PRICE) : 0;
                this.totalGrossFee = data.TOTAL_FEE_CLOSED ? parseFloat(data.TOTAL_FEE_CLOSED) : 0;
                const listSplit = data.LISTING_CLOSED_SPLIT_W_OA ? parseFloat(data.LISTING_CLOSED_SPLIT_W_OA) : 0;
                const buySplit = data.BUYING_CLOSED_SPLIT_W_OA ? parseFloat(data.BUYING_CLOSED_SPLIT_W_OA) : 0;
                const refListSplit = data.LISTING_CLOSED_SPLIT_W_RA ? parseFloat(data.LISTING_CLOSED_SPLIT_W_RA) : 0;
                const refBuySplit = data.BUYING_CLOSED_SPLIT_W_RA ? parseFloat(data.BUYING_CLOSED_SPLIT_W_RA) : 0;
                this.split = listSplit + buySplit + refBuySplit + refListSplit;
                this.striveGrossFee = this.totalGrossFee - this.split;
                break;
            }
            case 'Total (Neg/UC)':
                this.properties = negData.properties + ucData.properties;
                this.totalPrice = negData.totalPrice + ucData.totalPrice;
                this.totalGrossFee = negData.totalGrossFee + ucData.totalGrossFee;
                this.split = negData.split + ucData.split;
                this.striveGrossFee = negData.striveGrossFee + ucData.striveGrossFee;
                break;
            case 'Total Closed YTD': {
                this.properties = closedData.properties + closedOtherData.properties;
                this.totalPrice = closedData.totalPrice + closedOtherData.totalPrice;
                this.totalGrossFee = closedData.totalGrossFee + closedOtherData.totalGrossFee;
                this.split = closedData.split + closedOtherData.split;
                this.striveGrossFee = closedData.striveGrossFee + closedOtherData.striveGrossFee;
                break;
            }
        }
    }
}
